import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import {languagePicker, removeIgnoreItems, smallerImage} from '../../utils';
import queryString from 'query-string';
import history from '../../history';
import { getLabel, truncateWords } from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faChevronRight, faChevronLeft, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import SEO from '../../components/SEO/SEO';
import SearchPageHolder from './SearchPageStyle';
import { useMediaQuery } from 'react-responsive'

const SearchPage = (props) => {
    const currentUrl = queryString.parse(window.location.search);
    const [title, setTitle] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [searchResultTotal, setSearchResultTotal] = useState("");
    const [selectedOptionType, setSelectedType] = useState(currentUrl.type ? currentUrl.type : "all");
    const [selectedOptionOrder, setSelectedOrder] = useState(currentUrl.order ? currentUrl.order : "desc");
    let searchKey = currentUrl.key ? currentUrl.key : '';
    const [searchValue, setSearchValue] = useState(searchKey.replaceAll('\\', '').replaceAll('{', '').replaceAll('}', '').replaceAll('[','').replaceAll(']', ''));
    const [searchPage, setSearchPage] = useState(currentUrl.page ? Number(currentUrl.page <= 0 ? 1 : currentUrl.page) : 1);
    const [searchingData, setSearchingData] = useState(true);
    const [changePage, setChangePage] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [headerText, setHeaderText] = useState('');
    const [changeOption, setChangeOption] = useState(null);
    const [searchFieldMsg, setSearchFieldMsg] = useState(getLabel('SEARCHPLACEHOLDER'));
    const [pageDesc, setPageDesc] = useState('');
    const [pageThumb, setPageThumb] = useState([]);
    const siteURL = window.location.origin;
    const pageURL = window.location.origin + window.location.pathname;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
    const siteTitle = " | CPAC.ca";

    // lg 768 (1536 retina), md 576 (1152 retina), sm 269 (538 retina)
    const isFull = useMediaQuery({ query: '(min-width: 769px)' })
    const isLg = useMediaQuery({query: '(min-width: 577px) and (max-width: 768px'})
    const isMd = useMediaQuery({query: '(min-width: 270px) and (max-width: 576px'})
    const isSm = useMediaQuery({query: '(max-width: 269px'})
    const thumbSize = isFull ? "sm" : isLg ? "lg" : isMd ? "md" : isSm ? "sm" : "full" // full size actually uses tiny images
    useEffect(() => {
        const completeUrl = window.location.search;
        const params = queryString.parse(completeUrl);
        const craftConf = crafterConf.getConfig();
        const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

        searchingData && httpGet(serviceUrl, {url: props.url, crafterSite: craftConf.site, "key":params.key, "page":params.page, 
        "type":params.type, "order":params.order, "programId":params.programId, "tagId":params.tagId }).subscribe((data) => {
        let fieldNames = [
            "searchResult.title_t", "searchResult.description_t", "searchResult.image_s", "searchResult.altImageTxt_s",
            "searchResult.category_t", "searchResult.categoryURL_s", "searchResult.url_s", "header_text_html", 
            "thumbnailResult.image_s", "thumbnailResult.altImageTxt_s"
        ]
        if(data.page.searchResult && data.page.searchResult.item && data.page.searchResult.item.length > 0) {
            data.page.searchResult.item = removeIgnoreItems(data.page.searchResult);
        }
        languagePicker(data, fieldNames);
        let dataPage = data.page;
        dataPage.searchResult && setTotalPages(Number(dataPage.searchResult.totalPages));
        setTitle(params.key);
        setSearchResultTotal(dataPage.searchResult !== null ? dataPage.searchResult.total : null);
        setSearchResult(dataPage.searchResult !== null ? dataPage.searchResult.item : null);
        setSearchingData(false);
        setChangePage(false);
        setChangeOption(false);
        setHeaderText(dataPage.header_text);
        setPageThumb(dataPage.thumbnailResult.item[0].image);
        window.scrollTo(0, 0);

        if(params.programId || params.tagId){
            setSearchFieldMsg(getLabel('SEARCHINRESULTS'));
        }else{
            setSearchFieldMsg(getLabel('SEARCHPLACEHOLDER'));
        }

        const regex = /(<([^>]+)>)/ig;
        const descText = data.page.header_text.replace(regex, '').replace(/&egrave;/g, 'è').replace(/&eacute;/g, 'é').replace(/&ccedil;/g, 'ç').replace(/&rsquo;/g, "'");
        setPageDesc(descText);
        });
        
    }, [props.url, props.current_lang, searchingData]);

    useEffect(()=> {
		props.setCurrentLanguage(props.lan);
    },[props.lan]);
    
    useEffect(()=> {
		setSearchingData(true);
    },[props.current_lang]);

    const handleKeyPress = (e) => {
		if (e.key === 'Enter' || e.keyCode === 13) {
			submitForm(e);
		}
	}

    const renderResults = () => {
        if(searchingData === true) {
            return <li>{getLabel("LOADING")}</li>
        } else {
            if(searchResult && searchResult.length > 0) {
                return renderLinks();
            }
        }
        return <li>{getLabel("NORESULTS")}</li> 
    }

    const renderLinks = () => {
        return searchResult.map((result,i)=>{
            
            if(result.title != null && result.description != null){
                return(
                    <li className="list-main__item" key={i} itemProp='itemListElement' tabIndex="0">
                        {(result.type === 'program' || result.type === 'article') ? 
                        <FontAwesomeIcon icon={ faFileAlt } title="article"/>
                        : <FontAwesomeIcon icon={ faVideo } title="video"/>}
                        <div className="list-main__image">
                            <a href={result.url}> 
                                <img src={smallerImage(result.image, thumbSize)} alt={result.altImageTxt_s ? result.altImageTxt_s : (result.category + ": " + result.title)} itemProp='image' tabIndex="0"/>
                            </a>
                            {result.videoDuration && <span>{result.videoDuration}</span>}
                        </div>
                        <div className="list-main__content">
                            { 
                                result.category && 
                                <a href={result.categoryURL} className="featured-container__small-item-category" tabIndex="0"> 
                                    <p itemProp='subjectOf'>{result.category}</p>
                                </a>
                            }
                            <h2 className="list-main__title">
                                <a href={result.url} className="featured-container__small-item" tabIndex="0"> <p itemProp='name'>{result.title}</p></a>
                            </h2>
                            <p className="description_text" tabIndex="0" onClick={() => (window.location.href = result.url)} itemProp='description'>
                                {result.description && truncateWords(result.description, 225)}
                                {result.description && result.description.length > 225 && (
                                    <span className="description__ellipsis">(...)</span> 
                                )}
                            </p>
                        </div>
                    </li>
                )
            }
        });
    }
    useEffect(() => {
        if(changePage) {
            submitForm();
        }
    }, [changePage]);

    useEffect(() => {
        if(changeOption) {
            submitForm();
            setChangeOption(false);
        }
    }, [changeOption]);

    //funtion to handle each new request
    const submitForm = (e) => {
        const urlStr = window.location;
        const url = new URL(urlStr);

        if(e) {
            e.preventDefault();
            //url.searchParams.delete("tagId");
            //url.searchParams.delete("programId");
            setSearchPage(1);
        }

        url.searchParams.set("type", selectedOptionType);
        url.searchParams.set("order", selectedOptionOrder);
        url.searchParams.set("key", searchValue.replaceAll(":", "\\:").replaceAll("{", "").replaceAll("}", "").replaceAll("[", "").replaceAll("]", ""));
        url.searchParams.set("page", e ? 1 : searchPage);

        history.push(url.pathname + url.search);
        //function to trigger the http request on the useEffect
        setSearchingData(true);
    }
    const nextSearch = () => {
        const tempNum = Number(searchPage) + 1;
        //function to set the new page number
        setSearchPage(tempNum);
        //funtion to trigger the submitform after a next or previous button is cicked
        setChangePage(true);
    }
    const previousSearch = () => {
        const tempNum = Number(searchPage) === 1 ? Number(searchPage) : Number(searchPage) - 1;
        setSearchPage(tempNum);
        setChangePage(true);
    }

    const renderPagination = () => {
        return(
            <div className="pagination__control" id="pagination__control">
                <button
                    onClick={(e) => previousSearch(e)}
                    disabled={ searchPage === 1 || searchingData }
                >
                    <FontAwesomeIcon aria-hidden="true" icon={faChevronLeft} title='previous' />
                    { getLabel('PREVIOUS') }
                </button>
                <button
                    onClick={(e) => nextSearch(e)}
                    disabled={ searchingData || searchPage >= totalPages}
                >
                    { getLabel('NEXT') }
                    <FontAwesomeIcon aria-hidden="true" icon={faChevronRight} title='next' />
                </button>
			</div>
        );
    }

    function handleOptionChange (e) {
        setSelectedOrder(e.target.value);
        setChangeOption(true);
    }
    function handleTypeChange (e) {
        setSelectedType(e.target.value);
        setChangeOption(true);
        setSearchPage(1);
    }

    const renderForm = () => {
        return(
            <form role="search" method="get" className="search-form container" action="" onSubmit={(e) => submitForm(e)}>
                <div className="search-box">
                    <label>
                        <span className="screen-reader-text">
                            {`${getLabel('SEARCH_FOR')}`} { searchValue }
                        </span>
                        <input
                            type="search" 
                            className="search-field elasticpress-autosuggest" 
                            placeholder={searchFieldMsg}
                            value={searchValue}
                            aria-label={searchFieldMsg}
                            name="s"
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={(e)=> handleKeyPress(e)}
                        />
                    </label>
                    <button type="submit" className="search-submit">
                        { getLabel('SEARCH') }
                    </button>
                </div>
                <div className="form-input search-filters">
                    <label className="screen-reader-text" htmlFor="date">Order</label>
                    <div className="custom-select">
                        <select
                            name="order" 
                            onChange={(e) => handleOptionChange(e)}
                            id="order"
                            defaultValue={ selectedOptionOrder }
                            aria-label={selectedOptionOrder}
                        >
                            <option value="relevance">
                                { getLabel('RELEVANCE') }
                            </option>
                            <option value="desc">
                                { getLabel('DATE_NEWEST') }
                            </option>
                            <option value="asc">
                                { getLabel('DATE_OLDEST') }
                            </option>
                        </select>
                    </div>
                    <label className="screen-reader-text" htmlFor="type">Types</label>
                    <div className="custom-select">
                        <select
                            name="type" 
                            id="type" 
                            defaultValue={ selectedOptionType }
                            onChange={(e) => handleTypeChange(e)}
                            aria-label={selectedOptionType}
                        >
                            <option value="all" >
                                { getLabel('ALL_CONTENT') }
                            </option>
                            <option value="videos" >
                                { getLabel('VIDEOS') }
                            </option>
                            <option value="articles">
                                { getLabel('ARTICLES') }
                            </option>
                        </select>
                    </div>
                </div>
            </form>
        );
    }
    return (
        <>
        <SEO pageDesc={pageDesc} pageURL={pageURL} title={searchValue ? `${getLabel('SEARCH_FOR')}: ${searchValue}` : getLabel("SEARCH")} pageTitle={searchValue ? `${getLabel('SEARCH_FOR')}: ${searchValue}` + siteTitle : getLabel("SEARCH") +  siteTitle} image={siteURL + pageThumb} robots="false" pageLocale={pageLocale} />
        <SearchPageHolder>
            <header className="entry-header container" tabIndex="0">
				<h1 className="page-title" id="page-entry-title" itemProp='headline'>
                    {searchValue ? `${getLabel('SEARCH_FOR')}: ${searchValue}` : getLabel("SEARCH")}<span></span>
                </h1>
			</header>
            <div 
                tabIndex="0"
                className="headerText_container"
                dangerouslySetInnerHTML={{
                    __html: headerText,
                }}
            ></div>
            <div className="search-form-wrapper">
			    <div className="container--mid">
                    { renderForm() }
			    </div>
			</div>
            <div className="container-result-wrap" itemProp='mainEntity'>
                <div className="result-container">
                    <ul className="list-main" itemScope itemType='https://schema.org/ItemList'>
                        {renderResults()}
                    </ul>
                </div>
            </div>
            { renderPagination() }
        </SearchPageHolder>
        </>
    )
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps,mapDispatchToProps)(SearchPage);